import styled from 'styled-components';

export const UiExamPage = styled.div`
	display: block;
`;

export const UiExamContainer = styled.div`
	padding: 48px 32px;
`;